// removed by extract-text-webpack-plugin
module.exports = {"container":"_2suQP555MqGqndkwuwWWVe","icon":"_1WeJ6jTXRSYp2pAGIhamRZ","title":"_32iDrMCZMbKsbg1gLGgTBS","button":"_3QdbnaJ6Ji-6aQ2aEkNzT1"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/UpdateFea/styles.css
// module id = 2901
// module chunks = 0